import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EditState {
  editMode: boolean;
}

const initialState: EditState = {
  editMode: false,
};

const editSlice = createSlice({
  name: 'edit',
  initialState,
  reducers: {
    toggleEditMode(state) {
      state.editMode = !state.editMode;
    },
    setEditMode(state, action: PayloadAction<boolean>) {
      state.editMode = action.payload;
    },
  },
});

export const { toggleEditMode, setEditMode } = editSlice.actions;
export default editSlice.reducer;
